import React from "react";
import PropTypes from 'prop-types';

import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

import useUser from "../../../hooks/use-user";
import PageLoader from "../Common/PageLoader";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Forbidden from "../../pages/forbidden";

const Layout = ({ permissions = [] }) => {
    const location = useLocation();
    const { isCheckingState, isLoggedIn, userCan } = useUser();

    if (isCheckingState) return <PageLoader />;
    if (!isLoggedIn) return <Navigate to="/login" />;

    if (permissions.length > 0) {
        const isAllowed = permissions.some((per) => {
            return userCan(per);
        });

        if (!isAllowed) return <Forbidden />;
    }

    return (
        <div className="wrapper">
            <Header />

            <Sidebar location={location} />

            <section className="section-container">
                <Outlet />
            </section>

            <Footer />
        </div>
    );
};

Layout.propTypes = {
    permissions: PropTypes.array
}

export default Layout;
